export const EP_REACT_PROPS_OBSERVABLE_OBJECT = '__EP_REACT_PROPS_OBSERVABLE_OBJECT__';

export { ObservableObject } from './ObservableObject';
